/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartCheckoutOfferButton_item$ref = any;
type CartCheckoutOfferButton_transaction$ref = any;
type CartCustomHold_item$ref = any;
type CartMakeOfferButton_item$ref = any;
type CartPurchaseButton_item$ref = any;
type CartRequestPriceButton_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItemCTA_item$ref: FragmentReference;
export type CartItemCTA_item = {|
  +serviceId: ?string,
  +returnPolicy: ?{|
    +accept: ?any
  |},
  +shipmentQuotes: ?$ReadOnlyArray<?{|
    +totalAmount: ?{|
      +amount: ?number
    |}
  |}>,
  +pricing: ?{|
    +negotiable: ?any
  |},
  +lastTransaction: ?{|
    +$fragmentRefs: CartCheckoutOfferButton_transaction$ref
  |},
  +displayInfo: ?{|
    +ctas: ?{|
      +showAcceptOffer: ?boolean,
      +showMakeOffer: ?boolean,
      +showPurchase: ?boolean,
      +showRequestPrice: ?boolean,
    |},
    +pricing: ?{|
      +showOnHold: ?boolean,
      +showOnHoldCustom: ?boolean,
      +showSold: ?boolean,
    |},
  |},
  +$fragmentRefs: CartCustomHold_item$ref & CartRequestPriceButton_item$ref & CartCheckoutOfferButton_item$ref & CartPurchaseButton_item$ref & CartMakeOfferButton_item$ref,
  +$refType: CartItemCTA_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItemCTA_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartCustomHold_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartCheckoutOfferButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartPurchaseButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartMakeOfferButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartRequestPriceButton_item",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "returnPolicy",
      "storageKey": null,
      "args": null,
      "concreteType": "ReturnPolicy",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accept",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shipmentQuotes",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentQuote",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "totalAmount",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "negotiable",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "lastTransaction",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId",
          "type": "String!"
        }
      ],
      "concreteType": "Transaction",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "CartCheckoutOfferButton_transaction",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "displayInfo",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId",
          "type": "String"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp",
          "type": "PageDisplayEnum"
        }
      ],
      "concreteType": "ItemDisplayInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "ctas",
          "storageKey": null,
          "args": null,
          "concreteType": "CTADisplay",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showAcceptOffer",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showMakeOffer",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showPurchase",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showRequestPrice",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pricing",
          "storageKey": null,
          "args": null,
          "concreteType": "PriceInfoDisplay",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showOnHold",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showOnHoldCustom",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showSold",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c28676ea9603b8d9c483b22a38d09995';
module.exports = node;
